<template>
  <div class="watchassignment">
    <v-container>
      <h2>Watch Assignment</h2>
      <v-row>
        <v-col class="pb-0">
          <v-autocomplete
            dense
            label="Search Watch by People Name or ID"
            solo
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-simple-table dark>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">ID</th>
                  <th class="text-left">Assigned People</th>
                  <th class="text-left">Present</th>
                  <th class="text-left">Battery</th>
                  <th class="text-left">Edit</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.name">
                  <td>{{ item.id }}</td>
                  <td>{{ item.assignedpeople }}</td>
                  <td>{{ item.present }}</td>
                  <td>{{ item.battery }}</td>
                  <td>
                    <v-btn>Edit</v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          id: "123456789",
          assignedpeople: "XXX XXX",
          present: "yes",
          heartrate: "76",
          battery: "70%",
        },
        {
          id: "123456710",
          assignedpeople: "XXX XXX",
          present: "yes",
          heartrate: "76",
          battery: "70%",
        },
      ],
    };
  },
};
</script>